import EVENT from '../../enums/event.js';
import KEY from '../../enums/key.js';
import { TabTrapper } from '../../utils/tab-trapper.js';
import dispatchEvent from '../../utils/dispatch-event.js';

class Drawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.querySelector('[data-drawer]');

    if (!this.drawer) return;

    this.name = this.drawer.dataset.drawer;

    this.toggles = [
      ...document.querySelectorAll(`[data-drawer-toggle=${this.name}]`),
    ];

    this.currentTemplate = window.settings.template.current_template;

    this.registerEventListeners();
    this.hide();

    window.addEventListener('cart:rerendered', () => {
      const toggles = [
        ...document.querySelectorAll(`[data-drawer-toggle=${this.name}]`),
      ];

      toggles.forEach(toggle => {
        toggle.addEventListener('click', event => {
          event.preventDefault();

          dispatchEvent(EVENT.DRAWER.TOGGLE, toggle, {
            detail: {
              drawer: toggle.dataset.drawerToggle,
            },
          });
        });
      });
    });
  }

  /**
   * @returns {'closed'|'open'}
   */
  getState() {
    return this.drawer.dataset.state;
  }

  setState(state) {
    this.drawer.setAttribute('aria-hidden', (state === 'closed').toString());
    this.drawer.dataset.state = state;
  }

  registerEventListeners() {
    this.toggles.forEach(toggle => {
      toggle.addEventListener('click', event => {
        event.preventDefault();

        dispatchEvent(EVENT.DRAWER.TOGGLE, toggle, {
          detail: {
            drawer: toggle.dataset.drawerToggle,
          },
        });
      });
    });

    document.addEventListener('cart:rerendered', () => {
      if (this.currentTemplate !== 'cart') {
        setTimeout(() => {
          this.openDrawer();
        }, 200);
      }
    });

    document.addEventListener(EVENT.DRAWER.TOGGLE, event => {
      if (event.detail.drawer !== this.name) {
        this.closeDrawer();
        return;
      }

      if (this.getState() === 'open') {
        setTimeout(() => {
          this.closeDrawer();
        }, 200);

        return;
      }

      setTimeout(() => {
        this.openDrawer();
      }, 200);
    });
  }

  closeDrawer() {
    this.setState('closed');
    this.hide();

    dispatchEvent(EVENT.OVERLAY.DEACTIVATE, this.drawer);

    // Controlling focus
    if (this.focusElement) {
      this.focusElement.focus();
    }

    if (this.tabTrapper) {
      this.tabTrapper.close();
    }

    document.removeEventListener('keydown', event => {
      if (event.key === KEY.ESCAPE) {
        this.closeDrawer();
      }
    });
  }

  openDrawer() {
    this.show();
    this.setState('open');

    dispatchEvent(EVENT.OVERLAY.ACTIVATE, this.drawer);

    // Controlling focus
    this.focusElement = document.activeElement;
    this.drawer.focus();

    this.tabTrapper = new TabTrapper(this.drawer);

    document.addEventListener('keydown', event => {
      if (event.key === KEY.ESCAPE) {
        this.closeDrawer();
      }
    });
  }

  hide() {
    // Allow for the close animation before changing visibiliy.
    setTimeout(() => {
      this.drawer.classList.add('u-invisible');
    }, 500);
  }

  show() {
    this.drawer.classList.remove('u-invisible');
  }
}

customElements.define('generic-drawer', Drawer);
